import { SidebarBoxKey } from 'AdmissionsGuidance/StudentDashboard.types';
import { useTranslation } from 'react-i18next';
import { useTargetBrandConfig } from 'FrontRoyalAngular/useTargetBrandConfig';
import { memo, useMemo } from 'react';
import { useNavigationHelper } from 'FrontRoyalAngular/useNavigationHelper';
import { BasicDesktopBox } from '../../BasicDesktopBox';
import { type ButtonConfig } from '../../StudentDashboardSidebar.types';

function EmployerFundingBoxComponent() {
    const { t } = useTranslation('back_royal', { keyPrefix: 'employerFundingBox' });
    const brandConfig = useTargetBrandConfig();
    const { loadUrl } = useNavigationHelper();

    const buttons = useMemo(
        () => [
            {
                id: 'button_contact_us_employer_funding',
                text: t('buttonContactUs'),
                onPress: () => loadUrl(brandConfig.fundingContactUrl, '_blank'),
            },
        ],
        [t, brandConfig.fundingContactUrl, loadUrl],
    );

    return <EmployerFundingBoxPresentation buttons={buttons} />;
}

function EmployerFundingBoxPresentation({ buttons }: { buttons: ButtonConfig[] }) {
    const { t } = useTranslation('back_royal', { keyPrefix: 'employerFundingBox' });
    return (
        <BasicDesktopBox boxKey={SidebarBoxKey.employer_funding} headerText={t('heading')} buttons={buttons}>
            {t('content')}
        </BasicDesktopBox>
    );
}

export const EmployerFundingBox = memo(EmployerFundingBoxComponent) as unknown as typeof EmployerFundingBoxComponent;
